import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import { withStyles } from '@mui/styles'

import lang from 'lang'
import BuhlBankLogo from '@assets/images/banking/buhlBank.svg?url'
import SVGIcon from '../../../base/components/svg-icon/svg-icon'
import { Checkbox } from '../../../base/components/inputs'

const BankingCheckboxInput = (props) => {
  const { children, classes, ...otherProps } = props

  return (
    <div className={classes.container}>
      <Checkbox {...otherProps}>{children}</Checkbox>
      <Tooltip
        title={lang.bankingBuhlBankInputTooltip}
        classes={{ tooltip: classes.tooltip }}>
        <div className={classes.logo}>
          <SVGIcon svg={BuhlBankLogo} width='85px' height='25px' />
        </div>
      </Tooltip>
    </div>
  )
}

const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  logo: {
    display: 'flex',
    alignSelf: 'flex-end',
    marginTop: 15,
  },
  tooltip: {
    maxWidth: 200,
    marginRight: 50,
  },
})

export default withStyles(styles)(BankingCheckboxInput)
